import {createContext, useContext} from 'react';

import CablingMapEditorStore from './CablingMapEditorStore';

const CablingMapStoreContext = createContext(new CablingMapEditorStore());

export const CablingMapStoreProvider = CablingMapStoreContext.Provider;
export const useCablingMapStore = () => useContext(CablingMapStoreContext);
